import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { LocationTree } from '~/models/location/location'
import { Geolocation } from '~/models/common/types'
import {
  GoogleLocationGeocodeResult,
  GoogleLocationPlaceGeocodeResult,
  GooglePlace,
  GooglePlaceResult
} from '~/models/location/autocomplete/types'

@containerScoped()
export default class LocationService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  fetchLocations(location?: []): Promise<{ location: LocationTree[] }> {
    return this.requestBuilder
      .request('get', '/api/locations2-tree/')
      .params({ location })
      .send()
  }

  getLocationAutocompletePlaces(
    query: string,
    countryCodes: string[],
    sessionToken?: string
  ): Promise<GooglePlaceResult> {
    return this.requestBuilder
      .request('get', '/api/location/autocomplete')
      .params({
        query,
        country: countryCodes,
        sessionToken
      })
      .send()
  }

  geocodeGooglePlace(
    placeId: GooglePlace['placeId']
  ): Promise<GoogleLocationPlaceGeocodeResult> {
    return this.requestBuilder
      .request('get', `/api/location/places/${placeId}/details/`)
      .send()
  }

  geocodeGeolocation(
    geolocation: Geolocation
  ): Promise<GoogleLocationGeocodeResult> {
    return this.requestBuilder
      .request('get', '/api/location/geocode')
      .params({ lat: geolocation.lat, lon: geolocation.lon })
      .send()
  }
}
